import { Link, useLocation } from 'react-router-dom';
// @ts-ignore
import { breadcrumbMap } from '@/config/router';
import { Breadcrumb } from '@sinohealth/butterfly-ui-components/lib';
import lodash from 'lodash';
import style from './index.less';

const PageHeader = (props: any) => {
  const { breadcrumbMapData = breadcrumbMap } = props;
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    const item = lodash.get(breadcrumbMapData, pathSnippets.slice(0, index + 1).join('.'));
    return (
      <Breadcrumb.Item key={url}>
        {item?.path && index !== pathSnippets.length - 1 ? (
          <Link to={item?.path || ''}>{item?.label || '--'}</Link>
        ) : (
          item?.label || '--'
        )}
      </Breadcrumb.Item>
    );
  });
  const bNow = lodash.get(breadcrumbMapData, pathSnippets.join('.'));
  if (!bNow) return null;
  return (
    <div className={style.pageHeader}>
      <Breadcrumb>{extraBreadcrumbItems}</Breadcrumb>
      <div className={style.title}>{bNow.label || '--'}</div>
    </div>
  );
};

export default PageHeader;
